import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import cx from 'classnames';
import { isEmpty } from 'lodash-es';
import Tooltip from './Tooltip';
import Button from './Buttons/Button';

const NotificationAlertButton = ({
  notification = {},
  metaData = {},
  allowNotifications = true,
  allowedForCreation = true,
  showButtonName = false,
  enableTooltip = true,
  disabled = false,
  size,
  variant = 'secondary',
  iconClassName,
  customBtnName,
}) => {
  let url = '/alerts/new';
  let btnName = 'Create alert';
  if (allowNotifications) {
    if (isEmpty(notification)) {
      url = `/alerts/new?${qs.stringify(metaData)}`;
    } else {
      btnName = 'Update alert';
      url = `/alerts/${notification.parent_id || notification.id}/edit?${qs.stringify({ step: 2 })}`;
    }
  }

  return (
    <Tooltip content={allowedForCreation ? null : 'Alerts not available for this market.'} placement="left">
      <span className="notification-alert-wrapper">
        <Tooltip content={enableTooltip ? btnName : null} placement="bottomRight">
          <Button
            href={allowedForCreation ? url : '#'}
            className="notification-alert"
            disabled={disabled || !allowedForCreation}
            size={size}
            variant={variant}
            shape={!showButtonName ? 'square' : undefined}
            active={!isEmpty(notification)}
          >
            <i className={cx((isEmpty(notification) ? 'hicon-alert-bell-plus' : 'hicon-alert-bell-on'), iconClassName)} />
            {showButtonName ? <span className="ml-xs">{customBtnName || btnName}</span> : null}
          </Button>
        </Tooltip>
      </span>
    </Tooltip>
  );
};

NotificationAlertButton.propTypes = {
  notification: PropTypes.object,
  metaData: PropTypes.object,
  allowNotifications: PropTypes.bool,
  allowedForCreation: PropTypes.bool,
  disabled: PropTypes.bool,
  enableTooltip: PropTypes.bool,
  showButtonName: PropTypes.bool,
  size: PropTypes.string,
  variant: PropTypes.string,
  iconClassName: PropTypes.string,
  customBtnName: PropTypes.string,
};

export default NotificationAlertButton;
